import { render, staticRenderFns } from "./LoadingAnimation.vue?vue&type=template&id=c230b09c&scoped=true&"
import script from "./LoadingAnimation.vue?vue&type=script&lang=ts&"
export * from "./LoadingAnimation.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingAnimation.vue?vue&type=style&index=0&id=c230b09c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c230b09c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c230b09c', component.options)
    } else {
      api.reload('c230b09c', component.options)
    }
    module.hot.accept("./LoadingAnimation.vue?vue&type=template&id=c230b09c&scoped=true&", function () {
      api.rerender('c230b09c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/LoadingAnimation.vue"
export default component.exports